import { http } from 'utils/http';
import type { SignalingTokenResponse } from 'services/signaling';
import { getSignalingSocket } from 'services/signaling';

export const uploadAvatarService = async (
  file: File,
  roomId: string,
  userId: string
): Promise<{ url: string }> => {
  const { token } = await getSignalingSocket().sendAsync<SignalingTokenResponse>({
    event: 'requestUploadToken',
    data: { type: 'avatar' },
  });

  const formData = new FormData();
  formData.append('file', file);

  const { data } = await http.post<{ url: string }>(
    `/room-api/${roomId}/participants/${userId}/avatar`,
    formData,
    {
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'multipart/form-data',
      },
      timeout: 0,
    }
  );

  return data;
};

export const requestInvitationLinkService = async (role: string) => {
  const { url } = await getSignalingSocket().sendAsync<{ url: string }>({
    event: 'requestInvitationLink',
    data: {
      role,
    },
  });

  return url;
};
